<template>
  <span>{{ formatedAmount }}</span>
</template>

<script>
export default {
  name: 'SpendCell',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    formatedAmount() {
      const currencySign = this.row.currency || '$'
      if (!this.row.spend) return '--'
      return currencySign + parseFloat(this.row.spend).toFixed(2)
    }
  }
}
</script>